import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=560fb135&scoped=true&"
var script = {}
import style0 from "./page1.vue?vue&type=style&index=0&id=560fb135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560fb135",
  null
  
)

export default component.exports